/*

Main configuration file for this app

React only allows two environments natively (dev and prod), so
we have to manage our own env config :(

*/


/*
General Configuration
*/
const generalConfig = {
	STAGE: process.env.REACT_APP_STAGE,
}


/*
Environment-specific Configuration
*/
const environmentConfig = {

	/*
	Production Environment Configuration
	*/
	production: {
	//	API_URL: "https://api.adbookings.anza.org.sg"
		API_URL: "https://anza-advertising-api-2024-production-fdmgyc.laravel.cloud"
	},
	

	/*
	Staging Environment Configuration
	*/
	staging: {
		API_URL: "https://anza-advertising-api-2024-production-fdmgyc.laravel.cloud"
	},


	/*
	Development Environment Configuration
	*/
	development: {
		API_URL: "http://anza-advertising-api.local"
	},


	/*
	Local Environment Configuration
	*/
	local: {
		API_URL: "http://anza-advertising-api.local"
	}

}

const config = {
	...generalConfig,
	...environmentConfig[process.env.REACT_APP_STAGE]
}

export default config